<template>
    <div class="card shadow-22 formgrid p-fluid p-jc-start">

        <div class="field grid">
            <label class="col-12 md:col-3 font-bold">Inscrição</label>
            <div class="col-12 md:col-9">
                <label for="inscricao">{{ inscricao.codInscricao }}</label>
            </div>
        </div>

        <div class="field grid">
            <label for="nome" class="col-12 md:col-3 font-bold">Processo seletivo</label>
            <div class="col-12 md:col-9">
                <label id="nome">{{inscricao.id.selecaoEstagio.nome}}</label>
            </div>
        </div>

        <!-- <div class="field grid" v-if="!inscricao.id.selecaoEstagio.analiseDocumental">
            <label for="nome" class="col-12 md:col-3 font-bold">Data provável da prova</label>
            <div class="col-12 md:col-9">
                <label id="nome">{{ $formatarData(inscricao.id.selecaoEstagio.prova.dataHoraInicioProva) }}</label>
            </div>
        </div> -->

        <div class="field grid">
            <label for="tipo" class="col-12 md:col-3 font-bold">Tipo de seletivo</label>
            <div class="col-12 md:col-9">
                <label id="tipo">{{inscricao.id.selecaoEstagio.tipoSelecao.descricao}}</label>
            </div>
        </div>


        <div class="field grid">
            <label for="area" class="col-12 md:col-3 font-bold">Área</label>
                <div class="col-12 md:col-9">
                <label id="area">{{inscricao.area.area.nome}}</label>
            </div>
        </div>

        <div class="field grid" v-if="inscricao.id.selecaoEstagio.analiseDocumental">
            <label for="area" class="col-12 md:col-3 font-bold">Instituição de Ensino</label>
            <div class="col-12 md:col-9">
                <label id="area">{{inscricao.instituicaoEnsino ? inscricao.instituicaoEnsino.descricao : ""}}</label>
            </div>
        </div>

        <div class="field grid" v-if="inscricao.id.selecaoEstagio.tipoSelecao.estagio">
            <label for="area" class="col-12 md:col-3 font-bold">Coeficiente de rendimento escolar</label>
            <div class="col-12 md:col-9">
                <label id="area">{{inscricao.coefic_red_escolar}}</label>
            </div>
        </div>

        <div class="field grid">
            <label for="area" class="col-12 md:col-3 font-bold">Possui algum tipo de deficiência?</label>
            <div class="col-12 md:col-3">
                <label id="area">{{inscricao.concorreVagasReservadas ? 'Sim' : 'Não' }}</label>
            </div>
        </div>

        <div class="field grid">
                <label for="laudo" class="col-12 md:col-3 font-bold">Autodeclaração de Pessoa com Deficiência (PcD)</label>
            <div class="col-12 md:col-3">
                <Button id="download" label="Autodeclaração PCD" icon="pi pi-download" @click="download(inscricao.id.usuario.comprovante_deficiencia.id, 'Autodeclaração PCD')" class="p-button-info" :disabled="!inscricao.concorreVagasReservadas"></Button>
            </div>
        </div>

        <div class="field grid" v-if="inscricao.concorreVagasReservadas">
            <label for="area" class="col-12 md:col-3 font-bold">Necessita de atendimento especial para a prova escrita?</label>
            <div class="col-12 md:col-9">
                <label id="area">{{inscricao.atendimento_especial ? 'Sim' : 'Não' }}</label>
            </div>
        </div>

        <div class="field grid" v-if="inscricao.atendimento_especial">
            <label for="area" class="col-12 md:col-3 font-bold">Descrição de atendimento especial para a prova escrita</label>
            <div class="col-12 md:col-9">
                <Textarea v-model="inscricao.desc_atend_especial" rows="5" cols="30" disabled />
            </div>
        </div>

        <div class="field grid" v-if="inscricao.id.selecaoEstagio.tipoSelecao.residencia">
            <label for="area" class="col-12 md:col-3 font-bold">Fui declarado isento de pagamento pelo Tribunal de Contas do Estado</label>
            <div class="col-12 md:col-9">
                <label id="isentoPagamento">{{inscricao.isentoPagamento ? 'Sim' : 'Não' }}</label>
            </div>
        </div>

        <div class="field grid p-fluid">
            <label for="area" class="col-12 md:col-3 font-bold">Documentos</label>
            <div class="col-12 md:col-3">
                <Button id="download" label="Documento de Identidade" icon="pi pi-download" @click="download(inscricao.id.usuario.comprovante_rg.id, 'Documento de identidade')" class="p-button-info"></Button>
            </div>
            <div class="col-12 md:col-3" v-if="inscricao.id.selecaoEstagio.tipoSelecao.estagio">
                <Button id="download" label="Declaração da faculdade" icon="pi pi-download" @click="download(inscricao.idDoccomprovanteMatId, 'Comprovante de matricula')" class="p-button-info" :disabled="!inscricao.idDoccomprovanteMatId"></Button>
            </div>
            <div class="col-12 md:col-3" v-if="inscricao.id.selecaoEstagio.tipoSelecao.estagio">
                <Button id="download" label="Histórico escolar" icon="pi pi-download" @click="download(inscricao.idDocComprovanteRedEscolarId, 'Historico escolar')" class="p-button-info" :disabled="!inscricao.idDocComprovanteRedEscolarId"></Button>
            </div>
            <div class="col-12 md:col-3" v-if="inscricao.id.selecaoEstagio.tipoSelecao.residencia">
                <Button id="download" label="Comprovante de Pagamento" icon="pi pi-download" @click="download(inscricao.idDocComprovantePagamento, 'Comprovante de Pagamento')" class="p-button-info" :disabled="!inscricao.temComprovantePagamento"></Button>
            </div>
        </div>

        <div class="field grid">
            <label for="situacao" class="col-12 md:col-3 font-bold">Situação da inscrição</label>
                <div class="col-12 md:col-9">
                <label id="situacao">{{inscricao.descricaoStatus}}</label>
            </div>
        </div>

        <div class="field grid" v-if=" !inscricao.emAnalise">
            <label for="detalhes" class="col-12 md:col-3 font-bold">Detalhes</label>
            <div class="col-12 md:col-9">
                <label id="mensagem">{{inscricao.mensagem}}</label>
            </div>
        </div>
        <div class="field grid" v-else-if="inscricao.emAnalise">
            <label for="detalhes" class="col-12 md:col-3 font-bold">Detalhes</label>
            <div class="col-12 md:col-9">
                <label id="mensagem">Caso você tenha solicitado revisão da avaliação de documentos, receberá uma atualização após o período de avaliação de recurso</label>
            </div>
        </div>
        <div class="field grid" v-if="inscricao.exibirNotas && !inscricao.id.selecaoEstagio.analiseDocumental">
            <label for="detalhes" class="col-12 md:col-3 font-bold">Notas</label>
            <div class="col-12 md:col-2">
                <label class="font-bold">Prova Objetiva:</label> {{ inscricao.notaProva }}
            </div>
            <div class="col-12 md:col-2">
                <label class="font-bold">Prova Discursiva:</label> {{ inscricao.notaProvaDiscursiva }}
            </div>
            <div class="col-12 md:col-5">
                <label class="font-bold">Prova Final:</label> {{ inscricao.notaFinal }}
            </div>

        </div>

        <slot name="footer"></slot>

    </div>
</template>

<script>


import { validacaoFormulario } from '@/validacaoFormulario'
import http from '@/http';
export default {

    mixins: [validacaoFormulario],

    props: ['inscricao'],

    methods: {
        download(identificador, tituloArquivo){

                    var url = `inscricao/download/${identificador}`

                    http({
                        url: url,
                        method: 'GET',
                        responseType:'blob'
                    }).then(reponse => {

                        const fileBlob = new Blob([reponse.data])

                        const fileUrl = window.URL.createObjectURL(fileBlob)

                        const fileLink = document.createElement('a')
                        fileLink.href = fileUrl

                        tituloArquivo += '.pdf';
                        fileLink.setAttribute('download', tituloArquivo);
                        document.body.appendChild(fileLink)

                        fileLink.click()
                    })
        }
    }

}
</script>